<template>
  <div class="relative w-full h-full flex items-center justify-center">
    <div class="h-full flex-1 flex items-center justify-center relative">
      <div class="h-4/5 w-[90%] max-w-[1224px] relative -translate-y-[10%] shadow-1 mosaic rounded-xl overflow-hidden"
        v-if="fileModel">
        <div class="w-full h-full overflow-hidden">
          <EnhancePreLoad ref="preLoadRef" v-if="
            fileModel.status == uploadStatus.handle ||
            fileModel.status == uploadStatus.lodingImg
          " :fileModel="fileModel"></EnhancePreLoad>
          <div v-else-if="fileModel.status == uploadStatus.success" class="w-full h-full">
            <EnhanceCompareImg ref="compareImgRef" :origin="fileModel.preImage" :enhance="isVip
              ? fileModel.enhanceUrl
              : fileModel.watermark || fileModel.enhanceUrl
              " :minScale="minScale" :maxScale="maxScale" @scaleChange="CompareImgScaleChange" />
            <EnhanceGiveALike class="absolute right-4 bottom-4" v-if="isLogin"
              v-show="fileModel.enhanceUrl && !fileModel.isEvaluate" :id="fileModel.enhanceRecordId"
              @onEvaluate="onEvaluate"></EnhanceGiveALike>
          </div>
          <EnhanceImageView ref="imageViewRef" v-else :minScale="minScale" :maxScale="maxScale"
            :url="fileModel.preImage" @scaleChange="imageViewChange"></EnhanceImageView>
        </div>
      </div>
      <div v-else class="flex items-center justify-center">
        <FuncTypeUpload class="h-[240px] max-w-[90%] mx-auto z-[2] hidden sm:block xl:max-w-[1080px] lg:h-[280px]"
          :acceptCount="acceptCount" :funcType="funcType" :acceptList="acceptList"></FuncTypeUpload>
      </div>
      <div v-if="fileModel"
        class="absolute left-1/2 bottom-10 -translate-x-1/2 bg-white shadow-6 h-[88px] rounded-[20px] px-4 w-max">
        <div class="relative h-full flex items-center justify-between gap-x-4">
          <EnhanceBaseControls class="flex-1 flex justify-center" ref="baseControlsRef" :minScale="minScale"
            :maxScale="maxScale" @change="baseCtlScaleChange"></EnhanceBaseControls>
          <EnhanceApply @click="onApply" :enable="applyEnabled"></EnhanceApply>
        </div>
        <!-- 遮罩，部分流程禁止用户操作 -->
        <div class="absolute left-0 top-0 bottom-0 right-0 z-[2] cursor-not-allowed" v-if="
          !(
            fileModel.status === uploadStatus.success ||
            fileModel.status === uploadStatus.none ||
            fileModel.status === uploadStatus.fail ||
            fileModel.status === uploadStatus.uploadFail ||
            fileModel.status === uploadStatus.enhanceErr
          )
        "></div>
      </div>
    </div>
  </div>
</template>
<script setup>
import {
  minScale,
  maxScale,
  imageAccept,
  maxUploadCount,
} from "@/utils/config";
import { uploadStatus } from "@/utils/type";
import { useMainStore } from "@/store/index";
import { useUploadStore } from "@/store/upload";
const uploadStore = useUploadStore();
const {
  customEventNames,
  cleanMenuDownload,
  applyEvent,
  updateFileListEvent
} = useCustomEvent();
const props = defineProps({
  funcType: {
    type: String,
    default: "",
  },
  fileList: {
    type: Array,
    default: [],
  },
  currIndex: {
    type: Number,
    default: 0,
  },
  isFinish: {
    type: Boolean,
    default: false,
  },
  applyEnabled: {
    type: Boolean,
    default: false,
  },
});
const { getFuncType,funcTypeMap } = useFuncType();
const mainStore = useMainStore();
const FuncType = ref(getFuncType());
const fileModel = ref(null);
const { isLogin, isVip, isVipPro } = useUserInfo();
const acceptCount = computed(() => {
  return isVipPro.value ? maxUploadCount : 1;
});
const ColorMaster = ref(false);
const descratch = ref(false);
watch(
  () => props.fileList,
  () => {
    console.log("数据");
    if (props.fileList.length) {
      fileModel.value = props.fileList[0];
    } else {
      fileModel.value = null;
    }
  },
  { deep: true }
);
watch(
  () => props.currIndex,
  () => {
    console.log("数据");
    if (props.fileList.length) {
      fileModel.value = props.fileList[props.currIndex];
    } else {
      fileModel.value = null;
    }
  },
  { deep: true }
);
const compareImgRef = ref();

const baseControlsRef = ref(null);
const imageViewRef = ref(null);
const acceptList = ref(imageAccept);
onMounted(() => {
  window.addEventListener(customEventNames.uploadLocalFilesSuccessEvent, uploadLocalFilesSuccess);
  // nextTick(() => {
  //   if (props.fileList.length && props.fileList[0].enhanceUrl) {
  //     updateFileListEvent([
  //       {
  //         status: uploadStatus.none,
  //         originUrl: props.fileList[0].enhanceUrl,
  //         preImage: props.fileList[0].enhanceUrl,
  //         enhanceUrl: props.fileList[0].enhanceUrl,
  //         isEvaluate: true,
  //       },
  //     ]);
  //   }
  //   else if (props.fileList.length && props.fileList[0].file) {
  //     fileModel.value = props.fileList[0]
  //   }
  // })
});

onUnmounted(() => {
  uploadStore.setImages([]);
  updateFileListEvent([])
  window.removeEventListener(
    customEventNames.uploadLocalFilesSuccessEvent,
    uploadLocalFilesSuccess
  );
});
function uploadLocalFilesSuccess(e) {
  console.log(e.detail);
  const files = e.detail;
  if (files.length) {
    cleanMenuDownload()
  }
}
function baseCtlScaleChange(scale) {
  if (fileModel.value.status == uploadStatus.success) {
    compareImgRef.value.setScale(scale);
  } else {
    if (imageViewRef.value) {
      imageViewRef.value.setScale(scale);
    }
  }
}

function CompareImgScaleChange(scale) {
  baseControlsRef.value.setScale(scale);
}
function imageViewChange(scale) {
  baseControlsRef.value.setScale(scale);
}
function onApply() {
  if (isLogin.value) {
    let aiType = [6];
    switch (props.funcType) {
      case FuncType.value.ai_e_commerce.path:
        aiType = [59];
        if (ColorMaster.value) {
          aiType.push(53);
        }
        if (descratch.value) {
          aiType.push(14);
        }
        break;
      default:
        break;
    }
    useLogEvent({ eventName: "apply-"+funcTypeMap.png_hd});
    applyEvent({
      enhanceCfgIds: aiType,
    })
  } else {
    showLogin()
  }
}
function showLogin() {
  mainStore.setVisibleLogin(true);
}
function onEvaluate() {
  const fileList = [...props.fileList];
  fileList[props.currIndex].isEvaluate = true;
  updateFileListEvent(fileList)
}
</script>
